import { createContext, useContext, useState } from "react";

const DEFAULT_VALUE = {isOpen: false, payload: null}

const DialogueContext = createContext();

export const useDialogueState = () => {
    return useContext(DialogueContext)
}

export default function DialogueProvider({children}) {
    const [dialogueState, setDialogueState] = useState(DEFAULT_VALUE);

    const handleDialogueToggle = (isOpen, payload) => {
        if (!isOpen && !payload) {
            setDialogueState({isOpen: !dialogueState.isOpen, payload: null})
            return;
        }
        setDialogueState({isOpen, payload})
    }

    const value = {
        dialogueState,  
        setDialogueState,
        handleDialogueToggle
    }

    return (
        <DialogueContext.Provider value={value}>
            {children}
        </DialogueContext.Provider>
    )
}